import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'replaceStrings' })
export class ReplaceStringsPipe implements PipeTransform {
    transform(value: string): string {
        return value.replace(' - eventLocation', '');
    }
}
